import template from 'modal/user/create.j2';
import { checkForm } from '../utils/errorHandling';
import { init as forgotPasswordInit } from './forgotPasswordComponent';
import {
    clearLoginData,
    signupData,
    signupFailure,
    loginCanceled,
    loginFinished
} from '../actions/userActions';
import { userLoginSaga, loyaltyModalSaga } from '../sagas/userSagas';
import { LOGIN_METHOD_SIGNUP } from '../constants';
import { replaceModalTransition } from '../actions/modalActions';

import { modalShepherdSingleton } from '../../../core/js/components/modalShepherdComponent';
import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { generate } from '../../../core/js/utils/componentUtils';
import { debug } from '../../../core/js/utils/logger';
import { closeModal } from '../../../core/js/utils/modalUtils';
import { mDom, mDomMaintainInputVals } from '../../../core/js/utils/renderUtils';
import { removeHash } from '../../../core/js/utils/routerUtils';
import { launchAsyncLoginModal } from '@core/js/utils/asyncLaunchers';

function attachParsley(component, store) {
    debug('modal: attachParsleyForSignUp');

    $(component.scopedSelector('.js-signup-form')).parsley().on('field:validated', () => {
        const [values, msgs] = checkForm(component.scopedSelector('.js-signup-form'));

        let previousMsgs = {};

        if (store.getState().core.modal.create) {
            previousMsgs = store.getState().core.modal.create.messages;
        }
        store.dispatch(signupData(values, msgs, previousMsgs));
    });
}

function firstRender(store) {
    this.render(store, this);
    attachParsley(this, store);
}

function afterCancelAction(store) {
    store.dispatch(loginCanceled());
}

function afterCloseAction(store) {
    store.dispatch(clearLoginData());
    // Remove hash and push state on close
    removeHash();
}

/**
 * Attach component events to DOM
 * @returns {undefined}
 */
function attachEvents(store) {
    const _this = this;

    $(document).on(this.scopedEvent('submit'), this.scopedSelector('.js-signup-form'), (e) => {
        e.preventDefault();
        _this.attachLoader(store);

        const formData = {
            emailAddress: $(this.scopedSelector('[name=\'email\']')).val(),
            password: $(this.scopedSelector('[name=\'password\']')).val(),
            confirmPassword: $(this.scopedSelector('[name=\'confirmPassword\']')).val()
        };

        const firstNameCapture = document.getElementById('login-create-first-name');

        if (firstNameCapture) {
            const firstName = $('#login-create-first-name').val();

            formData.name = {
                firstName: firstName
            };
        }

        const createSubscriptionCheckbox = document.getElementById('login-create-email-subscription');

        const emailOptin = createSubscriptionCheckbox && createSubscriptionCheckbox.checked;

        if (emailOptin) {
            const source = $('#login-email-subscription-source').val();
            const gender = $('#login-email-subscription-gender').val();

            formData.emailSubscription = {
                source: source,
                gender: gender
            };
        }

        const payload = {
            formData: formData,
            method: LOGIN_METHOD_SIGNUP
        };

        store.runSaga(userLoginSaga, payload).done.then((tokenSession) => {
            const disableLoyaltyModal = _.get(store.getState(), 'core.loyaltyForm.disableModal', false);
            _this.removeLoader(store);

            modalShepherdSingleton.outcome = {
                signupSuccessful: true
            };

            if (!disableLoyaltyModal) {
                store.runSaga(loyaltyModalSaga, e, _this.name);
            } else {
                _this.closeAction(store);
            }

            store.dispatch(loginFinished(tokenSession.userAuthToken));
        }).catch((err) => {
            _this.removeLoader(store);
            store.dispatch(signupFailure(err));
        });
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-user-login'), (e) => {
        e.preventDefault();
        launchAsyncLoginModal(e, _this.name);
    });

    $(document).on(this.scopedEvent('touchend click'), this.scopedSelector('.js-user-forgot-password'), (e) => {
        e.preventDefault();

        const payload = replaceModalTransition(forgotPasswordInit, {}, e, _this.name);

        $.event.trigger({
            type: payload.type,
            payload: payload
        });
    });

    // Close modal on back-button
    bindOnPopStateEvent(this, function(e) {
        closeModal(this, e);
    });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        firstRender: firstRender,
        watch: 'core.modal.create',
        template: template,
        name: 'modal.create',
        replace: 'once',
        afterCancelAction: afterCancelAction,
        afterCloseAction: afterCloseAction,
        renderType: mDom,
        renderOptions: mDomMaintainInputVals,
        loader: {}
    };

    return generate(config, store, overrides);
}
